// react and js
import { React, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui

// components
import Page from "../../components/Page";

// hooks

// layouts

// pages

// theme

// utils

// widgets
import WidgetPasswordReset from "../../widgets/password_reset/PasswordReset";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function PasswordReset() {
  const { t } = useTranslation();

  // eslint-disable-next-line
  return useMemo(() => {
    return (
      <Page title={t("pages.password_reset.title")}>
        <WidgetPasswordReset />
      </Page>
    );
  }, [t]);
}
